// チャットのスクロール追従ヘルパー（Web共通）。
//
// タイムラインの高さや表示領域が後から変わる場面（リンクプレビューの出現、入力欄の伸縮など）で、
// 「元々最下部を見ていた場合だけ」最新へ追従させるために使う。
// 途中まで遡って読んでいる人の位置は動かさない。

// 直近のスクロール可能な祖先を探す。
export function findScrollableParent(el) {
  let node = el?.parentElement;
  while (node && node !== document.body) {
    const overflowY = window.getComputedStyle(node).overflowY;
    if ((overflowY === "auto" || overflowY === "scroll") && node.scrollHeight > node.clientHeight + 1) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}

// column-reverse は CSS が自動で最下部を保つため、追従の対象外。
export function isBottomAnchoredByCss(scroller) {
  if (!scroller) return false;
  return window.getComputedStyle(scroller).flexDirection === "column-reverse";
}

export function isNearBottom(scroller, tolerancePx = 80) {
  if (!scroller) return false;
  const distanceFromBottom = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
  return distanceFromBottom <= tolerancePx;
}

export function scrollToBottom(scroller) {
  if (!scroller) return;
  scroller.scrollTop = scroller.scrollHeight;
}

// 要素が後から増やした高さ分を、最下部にいた場合だけ追従する。
export function followBottomIfNear(el, extraTolerancePx = 80) {
  const scroller = findScrollableParent(el);
  if (!scroller || isBottomAnchoredByCss(scroller)) return;
  const addedHeight = el?.offsetHeight || 0;
  if (isNearBottom(scroller, addedHeight + extraTolerancePx)) scrollToBottom(scroller);
}
